import { app } from '../../app';
import { Controller } from './info-sharing-accounts.controller';

app.component('infoSharingAccounts', {
    controller: Controller,
    templateUrl: require('./info-sharing-accounts.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts.component.js